import { styled } from '@mui/material';
import { Show } from 'react-admin';

import { detailContainerStyles } from '../styles';

export const ShowContainer = styled(Show)(detailContainerStyles);
